import { useRef } from "react";
import MgpTooltip from "../../elements/MgpTooltip/MgpTooltip";
import { handleKeyDown } from "../../utils/utils";


type ListOfFileUploadedProps = {
    fileName: string;
    onDownloadDocument?: () => void;
    onDeleteDocument?: () => void;
    onHandleFileChangeReplace?: (e: any) => void;
};

export default function ListOfFileUploaded({fileName, onDownloadDocument, onDeleteDocument, onHandleFileChangeReplace}: ListOfFileUploadedProps) { 
    const fileIndexRef = useRef<HTMLInputElement | null>(null);
    const handleClick = () => {
        fileIndexRef.current && fileIndexRef.current.click();
    }
return(
    <div className='bg-menthe-5 p-y-sm p-x-md mw-100'>
        <div className="grid-flex va-center jc-start" style={{flexWrap: "nowrap"}}>
        <i className="icon-coche noir" />
        <p className='link col-flex-4 col-sm-flex-4 link-upload button-bloc' style={{verticalAlign: "bottom !important"}} onClick={onDownloadDocument} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
            {fileName }
        </p>
        {
            onHandleFileChangeReplace &&    
                <div className="file-replacing-button">
                    <MgpTooltip text='Remplacer' children={<div role="button" onClick={() => handleClick()}><i className='icon-fleches'></i></div>} backgroundColor="transparent" textColor="#000"  />
                    <input type="file" id="file-replacing" onChange={onHandleFileChangeReplace} ref={fileIndexRef}/>
                </div>       
        }

        {
            onDeleteDocument && 
            <button className='close-button' onClick={(e: any) => {
                e.preventDefault()
                onDeleteDocument();
                }}>
                <MgpTooltip text='Supprimer' children={<p>x</p>} backgroundColor="transparent" textColor="#000"/>
            </button> 
        }

           
        </div>  
    </div>
)
}